import PropTypes from 'prop-types';
import React from 'react';
import get from 'lodash.get';
import WatchJS from 'melanke-watchjs';

import InstantEPriceButton from '../components/InstantEPriceButton';
import { extractEPriceData } from '../utils/utility';
import { ePriceButtonTrackEvent } from '../utils/analytics';

class InstantEPriceContainer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isModalVisible: false,
			loadingUserProfile: true,
			userLoggedIn: false
		};
		this.modalOpen = this.modalOpen.bind(this);
		this.modalClose = this.modalClose.bind(this);
		this.internalShowEprice = this.internalShowEprice.bind(this);
		this.checkUserProfile = this.checkUserProfile.bind(this);
	}

	componentDidMount() {
		const { pubsub } = window;

		if (pubsub) {
			pubsub.subscribe('instant-eprice.complete', () => {
				this.internalShowEprice();
			});
		}

		// if userProfile is loaded (!== undefined)
		if (window.DDC && window.DDC.userProfile) {
			this.checkUserProfile();
		}

		// if userProfile is not loaded yet (=== undefined) OR userProfile change its value
		WatchJS.watch(window.DDC, 'userProfile', this.checkUserProfile);

		// required to make instant eprice work on mobile
		const ddcSlideIn = get(window, 'DDC.mobile.slidein', undefined);
		if (this.props.isMobile && ddcSlideIn) {
			ddcSlideIn.init();
		}
	}

	componentWillUnmount() {
		WatchJS.noMore = true;
	}

	checkUserProfile() {
		const userProfile = get(window, 'DDC.userProfile', undefined);
		if (userProfile) {
			this.setState({
				loadingUserProfile: false
			});
			if (
				this.props.instantEpriceShowAllAfterLeadSubmit === 'true' &&
				(userProfile && Object.entries(userProfile).length !== 0) &&
				!this.state.isModalVisible
			) {
				this.internalShowEprice();
			} else {
				const { ePriceVehicles } = userProfile;
				if (ePriceVehicles) {
					const found = ePriceVehicles.find(
						vehicle =>
							vehicle.itemUUID === this.props.widgetInfo.vehicleId
					);
					// when user has the vehicle in their profile
					if (found && !this.state.isModalVisible) {
						this.internalShowEprice();
					}
					// when user does not have the vehicle in their profile but logs into MyCars
					else if (userProfile.profileId) {
						this.setState({
							userLoggedIn: true
						});
					}
				}
			}
		}
	}

	internalShowEprice(e) {
		const { pubsub } = window;
		const { ePriceDetail } = this.props;

		// vcda does not always return an eprice detail
		if (ePriceDetail && pubsub) {
			const { ePriceValue, ePriceDifference } = extractEPriceData(
				ePriceDetail
			);
			pubsub.publish('instant-eprice.show', {
				ePriceDifference,
				yourEPrice: ePriceValue
			});
		}

		this.props.showEPrice();
		WatchJS.noMore = true;

		if (e) {
			ePriceButtonTrackEvent(
				this.props.buttonLabel,
				this.props.widgetInfo.widgetName,
				this.props.widgetInfo.windowId,
				false
			);
		}
	}

	modalClose() {
		this.setState({
			isModalVisible: false
		});
		const { pubsub } = window;
		if (pubsub) {
			pubsub.subscribe('instant-eprice.open', this.modalOpen);
		}
	}

	modalOpen() {
		this.setState({
			isModalVisible: true
		});
		const { pubsub } = window;
		if (pubsub) {
			pubsub.subscribe('instant-eprice.cancel', this.modalClose);
		}
		ePriceButtonTrackEvent(
			this.props.buttonLabel,
			this.props.widgetInfo.widgetName,
			this.props.widgetInfo.windowId,
			true
		);
	}

	render() {
		const {
			isDisplayingEprice,
			buttonLabel,
			pendingLabel,
			widgetInfo: { vehicleId, vehicleCategory, pageAlias },
			buttonStyle,
			buttonMobileClass,
			disabled,
			preventMultipleEpriceLeads
		} = this.props;
		let clickAction = this.modalOpen;

		if (isDisplayingEprice) {
			return null;
		}
		if (this.state.userLoggedIn) {
			clickAction = this.internalShowEprice;
		}

		return (
			<InstantEPriceButton
				key="button"
				userLoggedIn={this.state.userLoggedIn}
				loadingUserProfile={this.state.loadingUserProfile}
				isModalVisible={this.state.isModalVisible}
				buttonLabel={buttonLabel}
				pendingLabel={pendingLabel}
				handleClick={clickAction}
				vehicleId={vehicleId}
				vehicleCategory={vehicleCategory}
				pageAlias={pageAlias}
				buttonStyle={buttonStyle}
				buttonMobileClass={buttonMobileClass}
				disabled={disabled}
				preventMultipleEpriceLeads={preventMultipleEpriceLeads}
			/>
		);
	}
}

InstantEPriceContainer.propTypes = {
	showEPrice: PropTypes.func.isRequired,
	isDisplayingEprice: PropTypes.bool.isRequired,
	disabled: PropTypes.bool.isRequired,
	ePriceDetail: PropTypes.arrayOf(
		PropTypes.shape({
			_type: PropTypes.string.isRequired,
			formatted: PropTypes.string.isRequired,
			key: PropTypes.string,
			label: PropTypes.string.isRequired,
			value: PropTypes.number.isRequired,
			isFinalPrice: PropTypes.bool,
			incentives: PropTypes.arrayOf(PropTypes.string)
		})
	),
	buttonLabel: PropTypes.string.isRequired,
	pendingLabel: PropTypes.string.isRequired,
	widgetInfo: PropTypes.shape({
		vehicleId: PropTypes.string.isRequired,
		vehicleCategory: PropTypes.string.isRequired,
		pageAlias: PropTypes.string.isRequired,
		windowId: PropTypes.string.isRequired,
		widgetName: PropTypes.string.isRequired
	}).isRequired,
	buttonStyle: PropTypes.string,
	buttonMobileClass: PropTypes.string.isRequired,
	instantEpriceShowAllAfterLeadSubmit: PropTypes.string,
	isMobile: PropTypes.bool.isRequired,
	preventMultipleEpriceLeads: PropTypes.bool.isRequired
};

InstantEPriceContainer.defaultProps = {
	ePriceDetail: [],
	buttonStyle: 'primary',
	instantEpriceShowAllAfterLeadSubmit: 'false'
};

export default InstantEPriceContainer;



// WEBPACK FOOTER //
// ./src/containers/InstantEPrice.jsx